'use client'

import { IconArrowLeft, IconSearch } from '@macarongfactory/web-icons'
import Link from 'next/link'
import { useRouter } from 'next/navigation'

import { MYCLE_BRIDGE_COMMANDS, requestBridge } from '@/shared/lib/appBridge'

import { RANK_TRACK_CODE, useRankTrackingContext } from '../_features/rank'

/** 인앱 상단바 높이(px) — Figma App 상단 Left Aligned Header */
export const RANK_IN_APP_TOP_BAR_HEIGHT_PX = 56

/**
 * 인앱 웹뷰 상단바 — Figma App_랭킹 리스트 (뒤로가기 + 검색)
 * 웹 검색 헤더 대신 노출. 타이틀 없이 좌 뒤로가기 / 우 검색.
 */
const RankInAppTopBar = () => {
  const router = useRouter()
  const track = useRankTrackingContext()

  const handleBack = () => {
    // 쌓인 히스토리가 있으면 이전 화면으로, 없으면 웹뷰 닫기
    if (typeof window !== 'undefined' && window.history.length > 1) {
      router.back()
      return
    }
    requestBridge.Mycle({ command: MYCLE_BRIDGE_COMMANDS.CLOSE_WEBVIEW })
  }

  return (
    <header
      className='sticky top-0 z-20 flex items-center justify-between bg-background-surface-default px-dimension-x5'
      style={{ height: RANK_IN_APP_TOP_BAR_HEIGHT_PX }}
    >
      <button
        type='button'
        aria-label='뒤로가기'
        onClick={handleBack}
        className='shrink-0'
      >
        <IconArrowLeft width={24} height={24} />
      </button>
      <Link
        href='/modoocar/search'
        aria-label='차종 검색'
        className='shrink-0'
        onClick={() =>
          track.itemClick(RANK_TRACK_CODE.HEADER, 'search_icon', '검색 클릭')
        }
      >
        <IconSearch width={24} height={24} />
      </Link>
    </header>
  )
}

export default RankInAppTopBar
